import {getLeagueByRating} from './getLeagueByRating';
import {LEAGUE_CONFIGS} from '../../configs/leagues';
import {LEAGUES} from '../../constants/leagues';
import {
  getGloryHallDailyCrystals,
  getLeagueDailyCrystals,
  RATING_DAILY_PENALTY,
} from '../../configs/ratingCrystals';

export const GOLD_LEAGUE_MIN_RATING = LEAGUE_CONFIGS
  .find((league) => league.id === LEAGUES.GOLD)?.minRating ?? 1500;

/**
 * Что игрок получает за завершившийся игровой день.
 *
 * Два независимых слагаемых:
 *   - за лигу: только золото и выше, вместе со списанием рейтинга;
 *   - за место в Зале славы: 1-3 место, независимо от лиги.
 *
 * Боты сюда не попадают — их отсекает вызывающая сторона (сервер), здесь
 * только правила начисления.
 *
 * @param {Object} params
 * @param {number} params.rating - рейтинг игрока на момент подведения итогов дня
 * @param {number|null} params.gloryPlace - место в Зале славы (1..3) или null
 * @returns {{leagueId: string|null, leagueCrystals: number, gloryCrystals: number,
 *   crystals: number, ratingDelta: number, ratingAfter: number}}
 */
export const resolveDailyRatingCrystals = ({rating = 0, gloryPlace = null} = {}) => {
  const league = getLeagueByRating(rating);
  const isGoldOrHigher = rating >= GOLD_LEAGUE_MIN_RATING;

  const leagueCrystals = isGoldOrHigher ? getLeagueDailyCrystals(league.id) : 0;
  const gloryCrystals = gloryPlace ? getGloryHallDailyCrystals(gloryPlace) : 0;
  // Пола нет: рейтинг может опуститься и ниже порога лиги — тогда назавтра
  // списания уже не будет
  const ratingDelta = isGoldOrHigher ? -RATING_DAILY_PENALTY : 0;

  return {
    leagueId: leagueCrystals > 0 ? league.id : null,
    leagueCrystals,
    gloryCrystals,
    crystals: leagueCrystals + gloryCrystals,
    ratingDelta,
    ratingAfter: rating + ratingDelta,
  };
};
